export const updateItem = <T>(oldList: T[], item: T, id: keyof T) => {
  oldList.splice(
    oldList.findIndex((p) => p[id] === item[id]),
    1,
    item,
  );
  return oldList;
};
